import { initializeApp } from 'firebase/app';
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import settings from "./settings";
const app = initializeApp(settings.firebaseConfig);
export const auth = getAuth(app);
const database = getDatabase(app);
export default database;
